<template>
  <div>
    <PageHeader class="mb-2"></PageHeader>
    <PageMain ref="main" :tableData="tableData" :loading="loading"> </PageMain>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
export default {
  components: { PageHeader, PageMain },
  props: {
    proofingSampleCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .customerProofingSampleDetailListApi({
          proofingSampleCode: this.proofingSampleCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res?.body?.data || []
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
